let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aM92M")).then(() => parcelRequire('lM2nS'));